import { RichText } from '@uswitch/ev-core/react'
import richTextFieldHasContent from '@uswitch/ev-utils/rich-text/has-content'
import { Type } from '@uswitch/spark.type'
import TrustpilotStars from './tp-stars'
import { getVariantPath } from '@uswitch/ev-utils/get-variant-path'
import { useEntity } from '@uswitch/ev-utils/context/selectors'
import { cf2imgix } from '../imgix-img'

export const stylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'elements',
    componentId: 'testimonialCard',
    variantName: variant,
    field,
  })

const ReviewerImage = ({ image, reviewer = '' }) => {
  const reviewerInitials = reviewer
    .split(' ')
    .filter((_, i, arr) => i === 0 || i === arr.length - 1)
    .map(word => word.charAt(0).toUpperCase())
    .join('')

  return (
    <Choose>
      <When condition={image?.file?.url}>
        <img src={cf2imgix(image.file.url)} alt={reviewer} sx={{ variant: stylePath('reviewerImage') }} />
      </When>

      <Otherwise>
        <Type.S1 sx={{ variant: stylePath('reviewerImage') }}>{reviewerInitials}</Type.S1>
      </Otherwise>
    </Choose>
  )
}

const TestimonialCard = ({
  rating,
  heading,
  review,
  authorName: reviewerName,
  authorImage: reviewerImage,
  reviewerLocation,
  // TODO: remove after migration
  customerRating,
  quote,
}) => {
  const image = useEntity(reviewerImage)

  return (
    <div sx={{ variant: stylePath('wrapper') }}>
      <div sx={{ mb: 16 }}>
        <If condition={richTextFieldHasContent(heading)}>
          <RichText
            content={heading}
            style={{
              '> *:first-child, > span:first-child > *:first-child': {
                mt: 0,
                mb: 16,
              },
            }}
          />
        </If>

        <TrustpilotStars rating={rating || parseFloat(customerRating)} />
      </div>

      <If condition={richTextFieldHasContent(review)}>
        <RichText content={review} />
      </If>

      <If condition={quote}>
        <Type.Body1 as='p'>{quote}</Type.Body1>
      </If>

      <If condition={reviewerName}>
        <footer sx={{ variant: stylePath('footer') }}>
          <ReviewerImage image={image} reviewer={reviewerName} />

          <div sx={{ variant: stylePath('reviewerInfo') }}>
            <Type.Bold1>{reviewerName}</Type.Bold1>

            <If condition={reviewerLocation}>
              <Type.Body1>{reviewerLocation}</Type.Body1>
            </If>
          </div>
        </footer>
      </If>
    </div>
  )
}

export const TestimonialCardConnected = ({ entry, ...rest }) => {
  const props = useEntity(entry)

  return <TestimonialCard {...props} {...rest} />
}

export default TestimonialCard
